import { combineReducers } from "redux"
import { connectRouter } from "connected-react-router"

import projects from "./projects"
import utils from "./utils"
import messages from "./messages"
import transfers from "./transfers"

/* Project */
import details from "./project/details"
import files from "./project/files"
import folders from "./project/folders"
import filesModals from "./project/modals"
import filter from "./project/filter"
import history from "./project/history"
import screener from "./project/screener"
import tags from "./project/tags"
import asperaSharing from "./project/aspera_sharing"
import requests from "./project/requests"
import screeners from "./project/screeners"
import packages from "./project/packages"
import customFields from "./project/custom_fields"
import defroster from "./project/defroster"
import screenerAttachments from "./project/screener_attachments"

import auth from "./user/auth"
import billing from "./user/billing"
import support from "./user/support"
import reviewers from "./user/reviewers"
import organizations from "./organizations"
import roles from "./settings/organizations/roles"
import members from "./settings/organizations/members"
import send from "./preview/send"
import projectFolders from "./project_folders"
import screenerRequest from "./screener_request"
import documentPreviewer from "./document_previewer"
import downloadLink from "./download_link"
import fileRequest from "./file_request"
import modals from "./modals"
import tour from "./tour"
import sharedScreeners from "./shared_screeners"
import ondemandVideos from "./ondemand_videos"
import screenerRooms from "./screener_rooms"

const createRootReducer = routerHistory => combineReducers({
  router: connectRouter(routerHistory),
  projects,
  projectFolders,
  user: combineReducers({
    auth,
    billing,
    support,
    reviewers
  }),
  modals,
  utils,
  messages,
  project: combineReducers({
    details,
    files: combineReducers({
      modals: filesModals,
      filter,
      items: files,
      folders,
      screener: screener,
      tags,
      asperaSharing
    }),
    customFields,
    history,
    requests,
    screeners,
    packages,
    defroster,
    screenerAttachments
  }),
  transfers,
  organizations,
  shared_screeners: sharedScreeners,
  settings: combineReducers({
    organizations: combineReducers({
      roles,
      members
    })
  }),
  preview: combineReducers({
    send
  }),
  screenerRequest,
  documentPreviewer,
  download_link: downloadLink,
  file_request: fileRequest,
  tour,
  ondemand_videos: ondemandVideos,
  screener_rooms: screenerRooms
})

export default createRootReducer
